<template>
	<h3>{{article.title}}</h3>
</template>

<script>
export default {
  props: ['article']
}
</script>



/** WEBPACK FOOTER **
 ** LbSubtitle.vue?6b8d664f
 **/